import { useMutation } from '@tanstack/react-query';
import { AuthContext, Button, Dialog, PendingUpload } from 'alurkerja-ui';
import { useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MyTaskContext } from './MyTask';

interface UploadSuratSakitProps {
  data: any;
}

export const UploadSuratSakit = ({ data }: UploadSuratSakitProps) => {
  const params = useParams();
  const navigate = useNavigate();
  const axiosInstance = useContext(AuthContext);
  const { resetSelectedTask } = useContext(MyTaskContext);

  const [uploadedFile, setUploadedFile] = useState<string[]>();
  const [isEmpty, setIsEmpty] = useState<boolean>();

  const { mutate, isLoading } = useMutation({
    mutationFn: () => {
      return axiosInstance.post(
        `/workflow/v1/bpmn/${params.bpmnProcessId}/${params.instanceID}/task/${data?.tasks[0].key}/submit`,
        { dokumen_pendukung: uploadedFile?.[0] },
      );
    },
    onSuccess: () => {
      Dialog.success({
        title: 'Berhasil',
        description: 'Pengajuan mengupload Surat Sakit',
        callback: () => {
          resetSelectedTask?.();
          navigate('/my-task');
        },
      });
    },
  });

  const handleSubmit = () => {
    if (uploadedFile?.length === 0) {
      setIsEmpty(true);
    } else {
      mutate();
    }
  };

  return (
    <div className="space-y-4">
      <PendingUpload
        onChange={file => {
          setIsEmpty(false);
          setUploadedFile(file);
        }}
        multiple={false}
      />
      {isEmpty && <span className="text-xs text-red-400">Mohon isi bagian ini</span>}
      <div className="ml-auto w-fit">
        <Button onClick={handleSubmit} loading={isLoading} data-testid="upload-button">
          Upload
        </Button>
      </div>
    </div>
  );
};
